import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class EnquiryService {
  static getEnquiry(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getEnquiry}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getEnquiry}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }
  static editEnquiry(item) {
  
      let api = '';
      api= `${API_BASE_URL}${API_PATHS.editEnquiry}`
      
      return axiosInstance
          .put(api,item)
          
  }

  
}

export default EnquiryService;